import { date as dateUtil } from '@eti/utils';

export const getLocalTime = (utcTime, timeFormat) => {
  const [hours, minutes] = utcTime.split(':').map((time) => parseInt(time, 10));
  const date = new Date();
  date.setUTCHours(hours, minutes);

  return date ? dateUtil.format(date, timeFormat) : '';
};
